import React, {useEffect, useRef, useState} from 'react';
import {useAmCharts} from "#app/hooks/useAmCharts";
import {initializeChart, setupAxes, setupDateRange, setupDynamicHeight, setupSeries} from './utils/chartSetup';
import {getBoundaryDates, prepareChartData} from './utils/dataProcessing';
import {addCurrentDateMarker, setupCategoryLabels, setupScrollbar} from './utils/chartElements';

const GoalsTimeline = ({
                           data,
                           client,
                           onGoalClick,
                           chartId = 'goalstimeline',
                           showPercents = false,
                           filterCompleted = false,
                           initialZoomYears = 10,
                           dynamicHeight = false,
                           minHeight = 354
                       }) => {
    const chartRef = useRef(null);
    const [containerHeight, setContainerHeight] = useState(minHeight);
    const { loading, error, am4core, am4charts, am4lang_ru_RU, isReady } = useAmCharts();

    useEffect(() => {
        if (!isReady || !am4core || !am4charts) return;

        let chart;

        if (!chartRef.current) {
            chart = initializeChart(am4core, am4charts, am4lang_ru_RU, chartId);
            chartRef.current = chart;
        } else {
            chart = chartRef.current;
        }

        // Подготовка данных
        const preparedData = prepareChartData(data, client, filterCompleted, showPercents);

        chart.data = preparedData.reverse();

        // Настройка осей
        setupAxes(chart, am4charts);

        // Настройка серии
        setupSeries(chart, am4charts, am4core, onGoalClick);

        // Получение границ дат
        const { earlierDate, olderDate } = getBoundaryDates(data, client);

        // Настройка диапазона дат
        const dateAxis = chart.xAxes.getIndex(0);
        setupDateRange(dateAxis, earlierDate, olderDate);

        // Маркер текущей даты
        addCurrentDateMarker(dateAxis, am4core);

        // Scrollbar
        setupScrollbar(chart, am4core);

        // Настройка меток категорий
        const categoryAxis = chart.yAxes.getIndex(0);
        setupCategoryLabels(categoryAxis, showPercents);

        // Zoom при готовности
        chart.events.on("ready", () => {
            dateAxis.zoomToDates(
                earlierDate.clone().startOf('year').toDate(),
                earlierDate.clone().add(initialZoomYears, 'years').endOf('year').toDate(),
                false,
                true
            );
        });

        // Динамическая высота
        if (dynamicHeight) {
            setupDynamicHeight(chart, minHeight, (height) => {
                setContainerHeight(height)
            });
        }

        return () => {
            if (chart) {
                chart.dispose();
                chartRef.current = null;
            }
        };
    }, [data, client, isReady, am4core, am4charts, am4lang_ru_RU, onGoalClick, chartId, showPercents, filterCompleted, initialZoomYears, dynamicHeight, minHeight]);

    if (loading || error) return null;

    return (
        <div
            id={chartId}
            style={{
                width: '100%',
                minHeight: `${containerHeight}px`,
                height: `${containerHeight}px`,
                fontSize: '18px',
            }}
        />
    );
};

export default GoalsTimeline;